import { useRef, useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import AboutIcon from '../../assets/img/logo/favicon.png';
import AboutImg from '../../assets/img/aboutus.jpg';
import AboutImg2 from '../../assets/img/aboutus2.jpg';
import Founder from '../../assets/img/team/ezekiel.png';
import ezekiel from '../../assets/img/team/ezekiel.png';
import adaeze from '../../assets/img/team/adaeze.png';
import isaac from '../../assets/img/team/isaac.png';
import justice from '../../assets/img/team/justice.png';
import Icon1 from '../../assets/img/icon/demand.png';
import Icon7 from '../../assets/img/logo/favicon.png';
import Icon8 from '../../assets/img/logo/favicon1.png';
import MissionImg from '../../assets/img/mission.png';
import VisionImg from '../../assets/img/vision.jpg';
import Connect from '../../assets/img/icon/connect.png';
import Icon2 from '../../assets/img/icon/rescue-safety-ring.png';
import Icon3 from '../../assets/img/icon/arrow-9.png';
import { ArrowRight, ArrowLeft  } from 'iconsax-react';
import empowerImg from '../../assets/img/empower.png'
//import Icon4 from '../../assets/img/icon/globe.png';
//import Icon5 from '../../assets/img/icon/coin-morph.png';
import Icon6 from '../../assets/img/icon/savings-pig.png';
//import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet-async";
import { IoMdArrowForward } from "react-icons/io";
import { IoArrowBack } from "react-icons/io5";

const coreValues = [
  {
    title: "INCLUSION",
    description: "At Cardplot, inclusion fuels everything we do. We create room for every voice, and through collaboration, we build solutions that work for all.",
    iconClass: "fa-solid fa-users"
  },
  {
    title: "CONNECTIVITY",
    description: "Connectivity at Cardplot goes beyond tech. It is about staying locally relevant and creating real community impact through solutions built with purpose for everyday Africans.",
    iconClass: "fa-solid fa-network-wired"
  },
  {
    title: "EXCELLENCE",
    description: "Excellence drives every aspect of Cardplot's operations, features, and experience. We proudly and relentlessly combine precision with passion.",
    iconClass: "fa-solid fa-star"
  },
  {
    title: "COMPATIBILITY",
    description: "Cardplot integrates seamlessly with how Africa transacts by bridging mobile-first experiences, real-time access, and next-gen financial tools for the continent’s bold innovators.",
    iconClass: "fa-solid fa-plug"
  },
  {
    title: "TRANSPARENCY",
    description: "We don’t just move money, we move trust by safeguarding your transactions through unshakable security, relentless accountability, and steadfast dependability.",
    iconClass: "fa-solid fa-lock"
  },
  {
    title: "PROFESSIONALISM",
    description: "We measure strict adherence to best practices, meticulous attention to detail, and commitment to ethical standards. We ensure reliable, high-calibre service at every touchpoint.",
    iconClass: "fa-solid fa-briefcase"
  }
];

const teamMembers = [
  {
    name: 'Ezekiel C. Egbetamah',
    position: 'CEO & Founder',
    img: ezekiel,
    linkedin: 'https://www.linkedin.com/in/ezekiel-cliffy',
    twitter: 'https://x.com/cliffy_ezekiel',  
  },
  //{ name: 'Justice Igoma', position: 'Product Lead', img: justice },
  {
    name: 'Adaeze Onuorah ',  
    position: 'Sales Executive',
    img: adaeze,
    linkedin: 'https://www.linkedin.com/in/adaezeonuorah/',
    twitter: 'https://x.com/Me_Adah',
  },
  {
    name: 'David Femi Isaac',
    position: 'Marketing & Contents',
    img: isaac,
    linkedin: 'https://www.linkedin.com/in/isaac-david-2083b3258/',
    twitter: '',
  },
  // { name: 'Justice Igoma', position: 'Product Developer', img: justice },
  {
    name: 'Justice Igoma',
    position: 'Product Lead',
    img: justice,
    linkedin: 'https://www.linkedin.com/in/justice-igoma-8a8275152/',
    twitter: 'https://x.com/JusticeIgoma',
  },
  // Add more team members here
];



function About() {
  const sliderRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleItems, setVisibleItems] = useState(1);
  const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;

  useEffect(() => {
    const updateVisibleItems = () => {
      const width = window.innerWidth;
      if (width >= 1024) setVisibleItems(3);
      else if (width >= 768) setVisibleItems(2);
      else setVisibleItems(1);
    };
    updateVisibleItems();
    window.addEventListener("resize", updateVisibleItems);
    return () => window.removeEventListener("resize", updateVisibleItems);
  }, []);

  const scrollAmount = 400;
  
  const nextSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft += scrollAmount;
      setCurrentIndex((prev) => Math.min(prev + 1, teamMembers.length - visibleItems));
    }
  };

  const prevSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft -= scrollAmount;
      setCurrentIndex((prev) => Math.max(prev - 1, 0));
    }
  };


  const goToSlide = (index) => {
    if (sliderRef.current) {
      const scrollWidth = sliderRef.current.scrollWidth;
      const containerWidth = sliderRef.current.clientWidth;
      const maxScrollLeft = scrollWidth - containerWidth;
      
      const newScrollLeft = (index / (teamMembers.length - 1)) * maxScrollLeft;
      sliderRef.current.scrollLeft = newScrollLeft;
    }
    setCurrentIndex(index);
  };

  const options = {
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    navText: [
      "<i className='fa fa-chevron-left'></i>",
      "<i className='fa fa-chevron-right'></i>"
    ],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 3
      },
      1000: {
        items: 3
      }
    }
  };

  // Custom arrow components
  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <ArrowRight className='slide-arrow' color='#0A95FF'/>
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <ArrowLeft className='slide-arrow' color='#0A95FF'/>
      </div>
    );
  }

  const settings = {
    dots: true,
    arrows: false,  // This enables the navigation arrows
    infinite: true,
    nav:false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    nextArrow: <SampleNextArrow />,  // Custom next arrow
    prevArrow: <SamplePrevArrow />,  // Custom prev arrow
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };


  const partners = {
    dots: false,
    autoplay: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  
  return (
    <>
     
      <Helmet>
        <title>About Us - Cardplot</title>
        <meta name="description" content="Discover the story behind Cardplot, a leading fintech platform that empowers individuals and businesses with seamless payment solutions tailored to meet the unique needs of Africa." />
      </Helmet>
      <section className='breadcrumb__section bg-overlay'>
        <div className="container">
          <div className='row'>
            <div className='col-md-12'>
              <div className="breadcrumb__title__head">
                <ol className="breadcrumb">
                  <li className="active"><img src={AboutIcon} style={{ width: '25px', height: '25px' }} alt="" /></li>
                </ol>
                <h2 className='breadcrumb__title'> About Us</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb__text">
                <h3 className='breadcrumb__text__head'> <span className='breadcrumb__text__head__span'>Empowering</span> Africa’s Financial Future, Seamlessly</h3>
                <p className='breadcrumb__text__content'>As a leading pan-African fintech platform, we empower individuals and businesses with seamless payment solutions tailored to meet the unique needs of the continent.</p>
              </div>
              <div className='d-flex gap-3 justify-content-center align-items-center' style={{ paddingTop: '40px' }}>
                <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                  Get Started
                </a>
                <Link to='/contact' className='btn btn__outline_primary text__dark'>Contact us</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='who__we__are__section'>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-lg-12'>
              <div className='who__we__are__box'>
                <div className='who__we__are__box__container'>
                  <div className='who__we__are__box__item'>
                    <div className='who__we__are__box__icon'>
                      <img src={Icon1} className='img-fluid spin' alt='' />
                    </div>
                    <h3 className='who__we__are__box__title'>Pan-African Access</h3>
                  </div>
                  <div className='who__we__are__box__item'>
                    <div className='who__we__are__box__icon'>
                      <img src={Icon3} className='img-fluid spins' alt='' />
                    </div>
                    <h3 className='who__we__are__box__title'>Real-Time Currency Conversion</h3>
                  </div>
                  <div className='who__we__are__box__item'>
                    <div className='who__we__are__box__icon'>
                      <img src={Icon6} className='img-fluid spin' alt='' />
                    </div>
                    <h3 className='who__we__are__box__title'>Financial Management</h3>
                  </div>
                  <div className='who__we__are__box__item'>
                    <div className='who__we__are__box__icon'>
                      <img src={Icon2} className='img-fluid rotate-circle' alt='' />
                    </div>
                    <h3 className='who__we__are__box__title'>Seamless and Secure Transactions</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row" style={{ paddingTop: '100px' }}>
            <div className='col-lg-6 mb-5 mb-lg-0'>
              <div className="who__we__are__content__image" >
                <img src={AboutImg} className='img-fluid' alt='' />
                <div className='who__we__are__content__image__overlay d-none d-lg-block'>
                  <img src={AboutImg2} className='img-fluid' alt='' />
                </div>
                <div className='who__we__are__content__image__overlay__text'>
                  <img src={Connect} className='img-fluid connect-icon' alt='' />
                  <h5 className='who__we__are__content__image__overlay__title text-white'>
                    Connecting 20+ African Countries
                  </h5>
                </div>
              </div>
            </div>
            <div className='col-lg-6 mb-5 mb-lg-0'>
              <div className='who__we__are__content'>
                <div className='d-flex mb-4 align-items-center gap-3'>
                  <img src={Icon7} alt="" className='who__we__are__content__icon' />
                  <h2 className='who__we__are__title'>Who We Are</h2>
                </div>
                <p className='who__we__are__content__text'>At Cardplot, we’re reshaping the way Africa connects financially. </p>
                <p className='who__we__are__content__text'>As a leading pan-African fintech platform, we empower individuals and businesses with seamless payment solutions tailored to meet the unique needs of the continent. </p>
                <p className='who__we__are__content__text'>Whether it’s managing cross-border transactions, accessing virtual multi-currency wallets, or using secure virtual cards, Cardplot makes financial exchange simple, affordable, and efficient.</p>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className='what__drives__us'>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-lg-12'>
              <h2 className='what__drives__us__title'>What Drives Us</h2>
            </div>
          </div>
          <div className='row w-half mb-4 align-items-center' style={{ paddingTop: '70px' }}>
            <div className='col-12 col-lg-7 mb-4 order-1 order-lg-1'>
              <div className='what__drives__us__content'>
                <div className='d-flex mb-4 align-items-center gap-3'>
                  <img src={Icon8} alt="" className='what__drives__us__icon' />
                  <h2 className='what__drives__us__subtitle'>OUR MISSION</h2>
                </div>
                <p className='what__drives__us__content__text'>Our mission is to provide cutting-edge innovation that bridges the gap between African currencies and countries, fostering inclusivity and economic growth. </p>
                <p className='what__drives__us__content__text'>With Cardplot, you can trust that every transaction is backed by security, reliability, and a commitment to empowering a financially connected Africa.</p>
              </div>
            </div>
            <div className='col-12 col-lg-5 mb-4 order-2 order-lg-2 d-flex justify-content-center'>
              <div className='what__drives__us__image'>
                <img src={MissionImg} className='img-fluid' alt='' />
              </div>
            </div>
          </div>
          <div className='row w-half mb-4 align-items-center' style={{ paddingTop: '70px' }}>
            <div className='col-12 col-lg-6 mb-4 order-lg-1 order-2 d-flex justify-content-center'>
              <div className='what__drives__us__image'>
                <img src={VisionImg} className='img-fluid' alt='' />
              </div>
            </div>
            <div className='col-12 col-lg-6 mb-4 order-lg-2 order-1'>
              <div className='what__drives__us__content'>
                <div className='d-flex mb-4 align-items-center gap-3'>
                  <img src={Icon8} alt="" className='what__drives__us__icon' />
                  <h2 className='what__drives__us__subtitle'>OUR VISION</h2>
                </div>
                <p className='what__drives__us__content__text'>Our mission is to provide cutting-edge innovation that bridges the gap between African currencies and countries, fostering inclusivity and economic growth. </p>
                <p className='what__drives__us__content__text'>With Cardplot, you can trust that every transaction is backed by security, reliability, and a commitment to empowering a financially connected Africa.</p>
              </div>
            </div>
          </div>
        </div>
        <div className='container' style={{ paddingTop: '150px' }}>
          <div className='row'>
            <div className='col-12 col-lg-5 mb-4'>
              <div className='about__founder__image'>
                <img src={Founder} alt="" className='about__founder__image__img img-fluid' />
                <div className='about__founder__image__overlay'>
                  <h5 className='about__founder__image__overlay__title'>Ezekiel C. Egbetamah </h5>
                  <p className='about__founder__image__overlay__subtitle'>CEO, Cardplot</p>
                </div>
              </div>
            </div>
            <div className='col-12 col-lg-7 mb-4'>
              <div className='how__it__started__content'>
                <h2 className='how__it__started__title'>How it all began..</h2>
                <div className="how__it__started__text">
                  <p>
                    The idea for Cardplot wasn’t born in a boardroom or during a casual brainstorm—it came from a moment of deep frustration and helplessness. Ezekiel Cliffy, the CEO and founder of Cardplot, found himself stranded financially during what should have been one of the happiest times of his life: his honeymoon in Ghana. Ezekiel and his wife arrived in Ghana, excited to explore the culture, beaches, and vibrant life of Accra. The newlyweds were full of dreams, eager to create memories that would last a lifetime. But their adventure hit an unexpected snag right at the start—accessing money.
                  </p>
                  <p className=''>
                    Ezekiel quickly realized that his Nigerian Naira was of little use in Ghana without a reliable way to exchange it for Cedis. With limited options and an unfamiliar system, what should have been a simple exchange became a mountain of frustration.
                  </p>
                  <p>
                    Ezekiel spent over seven hours navigating a maze of currency exchange bureaus, bank offices, and ATMs, each presenting its own set of challenges. Some refused Naira outright, others offered unfavorable rates, and local ATMs declined his cards.
                  </p>
                  <p>
                    “I remember standing in the heat, holding my wife’s hand, and feeling completely powerless,” Ezekiel says. “We were supposed to be enjoying our honeymoon, but instead, we were stuck waiting, trying to figure out how to access the money we already had.”
                    The struggle wasn’t just logistical; it was emotional. Ezekiel felt the weight of failing to provide the seamless experience his wife deserved.
                  </p>
                  <p>
                    Ezekiel had a moment of clarity. This wasn’t just his struggle—millions of Africans traveling, studying, or conducting business across borders faced similar challenges every day.
                    “At that moment, I realized that Africa’s financial systems were fragmented, leaving its people disconnected,” he recalls. “Why should it be so hard to access your own money just because you’ve crossed a border? That’s when the idea for Cardplot began to take shape.”
                    Returning home, Ezekiel committed himself to solving the problem he had experienced firsthand. He envisioned a platform that would eliminate these barriers, making it simple for Africans to transact, exchange, and manage money across borders.
                  </p>
                  <p>
                    The result was Cardplot—a platform designed to unite Africa through seamless financial solutions. Ezekiel wanted Cardplot to be more than just a payment tool; he wanted it to reflect the spirit of the continent—its resilience, innovation, and unity.
                  </p>
                  <p>
                    Ezekiel’s story became the driving force behind Cardplot’s mission: to create a Pan-African payment solution that empowers individuals and businesses to connect and thrive without the limitations of traditional systems.
                  </p>
                  <p>
                    “What happened to me shouldn’t happen to anyone else,” Ezekiel says. “Cardplot is here to ensure that whether you’re traveling, sending money to loved ones, or running a business, you have the tools to succeed.”
                  </p>
                  <p>
                    Cardplot stands as a symbol of what can happen when personal challenges spark innovation. Ezekiel’s experience is a reminder that even in moments of frustration, there’s an opportunity to create something meaningful.
                  </p>
                  <p>
                    Cardplot isn’t just a financial platform—it’s a solution born from a real need, designed for real people, and driven by a vision to connect Africa like never before.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className='our__core__values'>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-md-12'>
              <h2 className='our__core__values__title'>Our Core Values</h2>
            </div>
          </div>
          <div className="row">
            {coreValues.map((value, index) => (
              <div key={index} className="col-12 col-md-4 mb-4">
                <div className="our__core__values__item">
                  <div className="our__core__values__icon mb-3">
                    <i className={value.iconClass}></i>
                  </div>
                  <h3 className="our__core__values__subtitle">{value.title}</h3>
                  <p className="our__core__values__text">{value.description}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      <section className='team-section'>
        <div className=''>
          <div className=''>
            <div className='mb-4'>
              <h2 className='team__title'> Exceptional Minds Developing for Everyday Lives </h2>
              <p className='team__text'>
                Meet the passionate innovators driving Cardplot’s mission to connect Africa.
                Our team is dedicated to creating seamless financial solutions that empower individuals and businesses across the continent.
              </p>
            </div>
            <div className="team__display__section">
              <div className='team__cards__container mx-md-4 mx-2' ref={sliderRef}>
                 {/* <Slider {...settings}>
                  {teamMembers.map((member, index) => (
                    <div className='team__card' key={index}>
                      <img src={member.img} alt={member.name} className='team__card__img img-fluid' />
                      <div className='team__card__content'>
                        <h3 className='team__card__name'>{member.name}</h3>
                        <p className='team__card__position'>{member.position}</p>
                        <div className='team__card__social'>
                          <Link to='#'><i className="fa-brands fa-linkedin"></i></Link>
                          <Link to='#'><i className="fa-brands fa-square-x-twitter"></i></Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider> */}
                  {teamMembers.map((member, index) => (
                    <div className='team__card' key={index}>
                      <img src={member.img} alt={member.name} className='team__card__img img-fluid' />
                      <div className='team__card__content'>
                        <h3 className='team__card__name'>{member.name}</h3>
                        <p className='team__card__position'>{member.position}</p>
                        <div className='team__card__social'>
                          {member.linkedin && (
                            <Link to={member.linkedin}>
                              <i className="fa-brands fa-linkedin"></i>
                            </Link>
                          )}
                          {member.twitter && (
                            <Link to={member.twitter}>
                              <i className="fa-brands fa-square-x-twitter"></i>
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
              <div className="pagination__section d-flex justify-content-end align-items-center gap-3 mt-4 me-3">
                  <button className="btn btn-outline-dark rounded-circle p-2" onClick={prevSlide} disabled={currentIndex === 0}>
                      <IoArrowBack size={24} color="#0A95FF" />
                  </button>
          
                  {/* Pagination Dots */}
                  {/* <div className="d-flex gap-2">
                      {Array.from({ length: Math.ceil(teamMembers.length / visibleItems) }).map((_, index) => (
                        <div
                          key={index}
                          role="button"
                          onClick={() => goToSlide(index * visibleItems)}
                          className={`dot ${currentIndex === index * visibleItems ? "active" : ""}`}
                        />
                      ))}
                  </div> */}
          
                  <button className="btn btn-outline-dark rounded-circle p-2" onClick={nextSlide} disabled={currentIndex >= teamMembers.length - visibleItems}>
                      <IoMdArrowForward size={24} color="#0A95FF" />
                  </button>
              </div>


          </div>
        </div>
      </section>

      {/* <section className='partner__section padding__tb__100'>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <h2 className='partner__title'>Counted on by 1500+ Individuals & Businesses</h2>
            </div>
          </div>
          <Slider {...partners} className='partner__slider'>
            <div className='partner__card'>
              <img src={partner1} className='img-fluid' alt='partner' />
            </div>
            <div className='partner__card'>
              <img src={partner2} className='img-fluid' alt='partner' />
            </div>
            <div className='partner__card'>
              <img src={partner1} className='img-fluid' alt='partner' />
            </div>
            <div className='partner__card'>
              <img src={partner2} className='img-fluid' alt='partner' />
            </div>
            <div className='partner__card'>
              <img src={partner1} className='img-fluid' alt='partner' />
            </div>
            <div className='partner__card'>
              <img src={partner2} className='img-fluid' alt='partner' />
            </div>
          </Slider>
        </div>
      </section> */}

      <section className='empower__africa padding__tb__50'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='empower__africa__box'>
                <p>Cardplot empowers millions across Africa with seamless access to cross-border payments, virtual accounts, secure virtual cards, currency exchange, and innovative financial tools designed for individuals and businesses alike.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='empower_your_trade'>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6">
              <div className="empower__title">
                <h2>Ready to simplify your payments?</h2>
                <p>Simplify Your Exchange, Empower Your Trade</p>
                <div className='d-flex gap-3' style={{ paddingTop: '60px' }}>
                  <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                    Get Started
                  </a>
                  <Link to='/contact' className='btn btn__outline_primary'>Contact us</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="empower__img">
                <img src={empowerImg} className='img-fluid' alt="empower" />
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default About